/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const SET_FILTER_AND_SORT_DATA = 'SET_FILTER_AND_SORT_DATA';
export const TABLE_ACTION_LOADER = 'TABLE_ACTION_LOADER';
export default SET_FILTER_AND_SORT_DATA;
